<template>
  <div class="VmpAIChatTopicList">
    <div class="tools">
      <vh-button round type="primary" size="medium" @click="editTopic()">
        {{ $t('host.k_631001') }}
      </vh-button>
      <vh-input
        round
        class="search"
        :placeholder="$t('host.k_631002')"
        v-model="keyword"
        clearable
        size="medium"
        @clear="getTopicTableList"
        @keyup.enter.native="getTopicTableList"
      >
        <i class="vh-icon-search vh-input__icon" slot="prefix" @click="getTopicTableList"></i>
      </vh-input>
      <vh-select
        round
        size="medium"
        clearable
        v-model="topicStatus"
        :placeholder="$t('host.k_631003')"
        class="search-select"
        @change="getTopicTableList"
      >
        <vh-option :label="$t('host.k_631003')" value=""></vh-option>
        <vh-option
          v-for="(item, index) in statusGroup"
          :key="item + index"
          :label="item"
          :value="index"
        ></vh-option>
      </vh-select>
    </div>
    <div class="list">
      <!-- 表格与分页 -->
      <vh-table
        ref="tableList"
        :data="tableList || []"
        :height="360"
        :header-cell-style="{
          color: '#666',
          height: '56px'
        }"
      >
        <vh-table-column
          align="left"
          v-for="(item, index) in tableColumn"
          :key="index"
          :width="item.width"
          :label="item.label"
          :fixed="item.fixed"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span :class="item.key">
              <template v-if="item.key == 'topic_name'">
                <span>{{ scope.row[item.key] }}</span>
              </template>
              <template v-else-if="item.key == 'activation_mode'">
                <span>
                  {{ scope.row[item.key] == 1 ? $t('host.k_631004') : $t('host.k_631005') }}
                </span>
              </template>
              <template v-else-if="item.key == 'timed_start_setting'">
                <span>
                  {{ timeSettingDesc(scope.row[item.key]) }}
                </span>
              </template>
              <template v-else-if="item.key == 'chatbot_number'">
                <span class="botNum" @click="openBot(scope.row)">
                  {{ scope.row[item.key] }}
                </span>
              </template>
              <template v-else-if="item.key == 'sending_mode'">
                <span>
                  {{ scope.row[item.key] == 1 ? $t('host.k_631006') : $t('host.k_631007') }}
                </span>
              </template>
              <template v-else-if="item.key == 'chat_interval'">
                <span>{{ scope.row[item.key] }}{{ $t('host.k_631008') }}</span>
              </template>
              <template v-else-if="item.key == 'gift_interval'">
                <span>
                  {{
                    scope.row[item.key] == -1 ? '-' : `${scope.row[item.key]}${$t('host.k_631008')}`
                  }}
                </span>
              </template>
              <template v-else-if="item.key == 'status'">
                <div class="itemStatus">
                  <div class="prefix" :class="'prefix' + scope.row[item.key]"></div>
                  <div>{{ statusGroup[scope.row[item.key]] }}</div>
                </div>
              </template>
              <template v-else-if="item.key == 'updated_at'">
                <span>{{ scope.row[item.key] }}</span>
              </template>
              <template v-else>{{ scope.row[item.key] }}</template>
            </span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_631009')" align="left" width="206px" fixed="right">
          <template slot-scope="scope">
            <vh-button
              type="text"
              class="stopbtn"
              v-if="scope.row.status == 2"
              @click="stopTopic(scope.row)"
            >
              {{ $t('host.k_631010') }}
            </vh-button>
            <vh-button type="text" v-else @click="checkStatus(scope.row)">
              {{ $t('host.k_631011') }}
            </vh-button>
            <vh-button type="text" @click="copyTopic(scope.row)">
              {{ $t('host.k_631012') }}
            </vh-button>
            <vh-button type="text" @click="editTopic(scope.row)">
              {{ $t('host.k_631013') }}
            </vh-button>
            <vh-button type="text" @click="delTopic(scope.row)">
              {{ $t('host.k_631014') }}
            </vh-button>
          </template>
        </vh-table-column>
        <div class="" slot="empty">
          <NullMode class="search-no-data"></NullMode>
        </div>
      </vh-table>
      <Bot ref="bot"></Bot>
      <!-- <div class="pageList" v-if="total > limit">
      <vh-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :currentPage="pageNumber"
        @current-change="currentChangeHandler"
        @size-change="handleSizeChange"
      ></vh-pagination>
    </div> -->
    </div>
  </div>
</template>
<script>
  import { useRoomBaseServer, useChatServer, useMsgServer } from 'middle-domain';
  import NullMode from '@/packages/null-mode';
  import Bot from './bot';

  export default {
    name: 'VmpAIChatTopicList', // 发起端AI聊天列表弹窗
    components: {
      NullMode,
      Bot
    },
    data() {
      return {
        total: 0,
        pos: 0,
        pageNumber: 1,
        limit: 20,
        keyword: '',
        tableColumn: [
          {
            label: this.$t('host.k_631015'),
            key: 'content_title',
            width: '180px',
            fixed: 'left'
          },
          {
            label: this.$t('host.k_631016'),
            key: 'activation_mode',
            width: '100px'
          },
          {
            label: this.$t('host.k_631017'),
            key: 'timed_start_setting',
            width: '160px'
          },
          {
            label: this.$t('host.k_631018'),
            key: 'chatbot_number',
            width: '100px'
          },
          {
            label: this.$t('host.k_631019'),
            key: 'sending_mode',
            width: '100px'
          },
          {
            label: this.$t('host.k_631020'),
            key: 'chat_interval',
            width: '100px'
          },
          {
            label: this.$t('host.k_631021'),
            key: 'gift_interval',
            width: '100px'
          },
          {
            label: this.$t('host.k_631022'),
            key: 'status',
            width: '120px'
          }
        ],

        // 状态，0-未推送 1-已推送 2-推送中 3-等待推送
        statusGroup: [
          this.$t('host.k_631023'),
          this.$t('host.k_631024'),
          this.$t('host.k_631025'),
          this.$t('host.k_631026')
        ],
        tableList: [],
        topicStatus: ''
      };
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.chatServer = useChatServer();
    },
    async created() {
      const msgServer = useMsgServer();
      msgServer.$onMsg('ROOM_MSG', msg => {
        // console.log(msg);
        if (
          msg &&
          msg.data &&
          msg.data.type == 'chatbot_status_notice' &&
          msg.data.scene_type == 'topic'
        ) {
          // for (let index = 0; index < this.tableList.length; index++) {
          //   if (this.tableList[index].id == msg.data.id) {
          //     this.tableList[index].status = msg.data.status;
          //     break;
          //   }
          // }
          this.getTopicTableList();
        }
      });
      this.initComponent();
    },
    methods: {
      timeSettingDesc(timedStartSetting) {
        if (timedStartSetting.type == 0) {
          return this.$t('host.k_631035');
        } else if (timedStartSetting.type == 1) {
          return this.$t('host.k_631036', [
            timedStartSetting.start_delay_minutes,
            timedStartSetting.duration_minutes
          ]);
        }
        return '';
      },
      initComponent() {
        this.getTopicTableList();
      },
      // initQueryUserList() {
      //   this.pos = 0;
      //   this.pageNumber = 1;
      //   this.limit = 20;
      //   // 表格切换到第一页
      //   this.$nextTick(() => {
      //     if (this.$refs.tableList && this.$refs.tableList.pageInfo) {
      //       this.$refs.tableList.pageInfo.pageNum = 1;
      //       this.$refs.tableList.pageInfo.pos = 0;
      //     }
      //     this.getTopicTableList();
      //   });
      // },
      async getTopicTableList(row) {
        if (row) {
          this.pos = row.pos;
          this.pageNumber = row.pageNum;
        }
        // this.loading = true;
        let params = {
          keyword: this.keyword,
          status: this.topicStatus
          // pos: this.pos,
          // limit: this.limit
        };
        let res = await this.chatServer.getTopicList(params);
        this.total = res.data.total;
        this.tableList = res.data.list;
        if (!this.keyword && this.topicStatus === '') {
          this.$emit('upTotal', this.total);
        }
      },
      stopTopic(row) {
        this.chatServer
          .stopPushTopic({
            topic_id: row.id
          })
          .then(res => {
            if (res.code != 200) {
              this.$vhMessage.error(res.msg);
            }
            this.getTopicTableList();
          });
      },
      checkStatus(row) {
        if (this.roomBaseServer.state.watchInitData.webinar.type == 1) {
          const flag = this.tableList.filter(e => {
            return e.status == 2;
          });
          // console.log(flag);
          if (flag.length > 0) {
            this.$vhConfirm(
              this.$t('host.k_631027'),
              this.$t('host.k_631028'),

              {
                confirmButtonText: this.$t('host.k_631029'),
                cancelButtonText: this.$t('host.k_631030'),
                roundButton: true
              }
            ).then(() => {
              this.startTopic(row);
            });
          } else {
            this.startTopic(row);
          }
        } else {
          this.$message({
            message: this.$t('host.k_631031'),
            showClose: true,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        }
      },
      startTopic(row) {
        this.chatServer
          .startPushTopic({
            topic_id: row.id
          })
          .then(res => {
            if (res.code != 200) {
              this.$vhMessage.error(res.msg);
            }
            this.getTopicTableList();
          });
      },
      openBot(row) {
        this.$refs.bot.open(row.id);
      },
      editTopic(topicData) {
        this.$emit('editTopic', topicData);
      },
      copyTopic(topicData) {
        this.chatServer.copyTopic({ copied_id: topicData.id }).then(res => {
          if (res.code == 200) {
            this.$vhMessage({
              message: this.$t('host.k_631032'),
              showClose: true,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.getTopicTableList();
          } else {
            this.$vhMessage({
              message: res.msg,
              showClose: true,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          }
        });
      },
      delTopic(topicData) {
        this.$vhConfirm(this.$t('host.k_631033'), this.$t('host.k_631028'), {
          confirmButtonText: this.$t('host.k_631029'),
          cancelButtonText: this.$t('host.k_631030'),
          roundButton: true
        }).then(() => {
          this.chatServer.deleteTopic({ topic_ids: topicData.id }).then(res => {
            if (res.code == 200) {
              this.$vhMessage({
                message: this.$t('host.k_631034'),
                type: 'success'
              });
            } else {
              this.$vhMessage({
                message: res.msg,
                type: 'error'
              });
            }
            this.getTopicTableList();
          });
        });
      }
      // // 页码改变按钮事件
      // currentChangeHandler(current) {
      //   this.pageNumber = current;
      //   this.pos = parseInt((current - 1) * this.limit);
      //   this.getTopicTableList();
      // },
      // // 每页显示个数选择器的选项设置 改变按钮事件
      // handleSizeChange(current) {
      //   this.pageNumber = 1;
      //   this.limit = current;
      //   this.pos = parseInt((this.pageNumber - 1) * this.limit);
      //   this.getTopicTableList();
      // }
    }
  };
</script>
<style lang="less">
  .VmpAIChatTopicList {
    .tools {
      margin-bottom: 16px;
      overflow: hidden;
      .search {
        float: right;
        width: 220px;
        height: 36px;
        .vh-input__inner {
          height: 36px;
          .vh-input__icon {
            line-height: 36px;
          }
        }
      }
      .search-select {
        float: right;
        width: 140px;
        margin-right: 12px;
      }
    }
    .list {
      color: #1a1a1a;
      .vh-table {
        margin-bottom: 24px;

        .vh-table__body .cell {
          .botNum {
            color: #3562fa;
            cursor: pointer;
          }
          .stopbtn {
            color: #fb3a32;
          }
          .itemStatus {
            display: flex;
            align-items: center;
            .prefix {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin-right: 4px;
              &.prefix0 {
                background-color: #fc9600;
              }
              &.prefix1 {
                background-color: #0fba5a;
              }
              &.prefix2 {
                background-color: #0a7ff5;
              }
            }
          }
        }
      }
    }
    .pageList {
      text-align: center;
      // padding-top: 24px;
    }
  }
  // .el-message-box__wrapper {
  //   z-index: 3001 !important;
  // }
</style>
